import { ProductTag } from '../../types/product.types';

const DEFAULT_TAG_COLOR = '#3b82f6';

const buildKey = (tag: ProductTag): string => {
  if (typeof tag.id === 'number') {
    return `id-${tag.id}`;
  }
  return `name-${tag.name.toLowerCase()}`;
};

export const normalizeTag = (tag: any): ProductTag | null => {
  if (!tag) {
    return null;
  }

  if (typeof tag === 'string') {
    return {
      name: tag,
      color: DEFAULT_TAG_COLOR,
    };
  }

  if (typeof tag === 'object') {
    const name = tag.name ?? tag.label ?? '';
    if (!name) {
      return null;
    }

    return {
      id: typeof tag.id === 'number' ? tag.id : undefined,
      name,
      color: tag.color || DEFAULT_TAG_COLOR,
      description: tag.description,
    };
  }

  return null;
};

export const normalizeTags = (tags?: any[]): ProductTag[] => {
  if (!Array.isArray(tags)) {
    return [];
  }

  const mapped = tags.map(normalizeTag).filter((tag): tag is ProductTag => tag !== null);

  const uniqueMap = new Map<string, ProductTag>();
  mapped.forEach((tag) => {
    uniqueMap.set(buildKey(tag), tag);
  });

  return Array.from(uniqueMap.values());
};

export const compareTags = (a: ProductTag, b: ProductTag): boolean => {
  if (typeof a.id === 'number' && typeof b.id === 'number') {
    return a.id === b.id;
  }
  return a.name.toLowerCase() === b.name.toLowerCase();
};

export const removeDuplicateTags = (tags: ProductTag[]): ProductTag[] => {
  const uniqueMap = new Map<string, ProductTag>();
  tags.forEach((tag) => {
    uniqueMap.set(buildKey(tag), tag);
  });

  return Array.from(uniqueMap.values());
};

export const tagArrayToIdList = (tags: ProductTag[]): number[] => {
  return tags
    .map((tag) => (typeof tag.id === 'number' ? tag.id : null))
    .filter((id): id is number => id !== null);
};
